import { useRef, useState } from 'react'
import Modal from '@mui/material/Modal';
import ReactPlayer from "react-player";
import { isMobileDevice } from 'src/components/WidgetMaker/WidgetDnD/isMobileDevice';
import { formatDate } from 'src/components/ProductScheduler/utils';
import { isVideoUrl } from 'src/components/DesignSystem/ModernTheme/utils/videoUtility';
import { ChevronType1 } from '../../../Carousel/components/Chevrons/ChevronTypes/ChevronType1';
import { ArrowIcon } from '../../../Carousel/components/Arrows';

const RenderInstaModal = (props: any) => {
  const { config, setConfig, handlePrevPost, handleNextPost } = props;
  const [showReadMore, setShowReadMore] = useState(true);
  const carouselRef = useRef(null);
  const isMobile = isMobileDevice();
  const mobilePostRef = useRef(null);
  const [currentSlideActive, setCurrentSlideActive] = useState(0);

  function handleNextClick(post) {
    if ((post?.length - 1) > currentSlideActive) {
      carouselRef.current?.scrollBy({
        top: 0,
        left: 680,
        behavior: 'smooth',
      });
      setCurrentSlideActive(prev => prev + 1)
    }
  }

  function handlePrevClick() {
    if (currentSlideActive > 0) {
      carouselRef.current?.scrollBy({
        top: 0,
        left: -680,
        behavior: 'smooth',
      });
      setCurrentSlideActive(prev => prev - 1)
    }
  }


  function handleClose() {
    setConfig(prev => {
      return {
        ...prev,
        showModal: false
      }
    })
  }

  function renderImage(post, imageStyle = {}) {
    return (
      <img
        src={post}
        loading='lazy'
        style={{ ...imageStyle }}
        className={`tw-object-contain tw-bg-black ${!isMobile ? 'tw-max-w-[680px] tw-h-[100%] tw-rounded-tl-[12px] tw-rounded-bl-[12px]' : 'tw-max-h-[400px] tw-w-[100%] tw-flex tw-items-center'} removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer`} />
    )
  }

  function renderVideo(postData, videoStyle = {}) {
    return (
      <div className={`tw-flex tw-bg-black ${!isMobile ? 'tw-flex-col tw-justify-center tw-h-[100%] tw-rounded-tl-[12px] tw-rounded-bl-[12px]' : 'tw-items-center tw-max-h-[400px] tw-w-[100%] tw-flex'} tw-object-contain tw-bg-black`}>
        <ReactPlayer
          url={postData}
          controls
          width={"100%"}
          playing
          style={{
            maxHeight: !isMobile ? '600px' : '492px',
            maxWidth: !isMobile ? '680px' : '100%',
            borderRadius: !isMobile ? '12px 0 0 12px' : '',
            overflow: !isMobile ? 'hidden' : '',
            ...(isMobile ? { display: 'flex' } : {}),
          }}
          {...(!isMobile ? { height: '100%' } : '')}
          {...(videoStyle)}
        />
      </div>
    )
  }

  function getMaxHeight() {
    return mobilePostRef?.current?.clientHeight || ''
  }

  function renderImageAndVideo(config) {
    const mediaUrl = config?.post?.parent_media?.media_url;
    if (config?.post?.child_media?.length) {
      const style = {
        maxWidth: isMobile ? '768px' : '680px',
        maxHeight: isMobile ? '100%' : '600px',
        height: isMobile ? '400px' : '600px',
        width: isMobile ? mobilePostRef?.current?.clientWidth : '680px'
      }
      return (
        <div className={`tw-relative ${isMobile ? 'tw-w-[100%] tw-h-[400px]' : 'tw-w-max tw-h-max'}`}>
          <div ref={carouselRef} style={{ overflow: 'auto visible' }} className={`no-scrollbar tw-flex ${!isMobile ? 'tw-w-[680px] tw-h-[600px] tw-rounded-tl-[12px] tw-rounded-bl-[12px]' : 'tw-w-[100%] tw-h-[400px]'}`}>
            <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10 tw-flex">
              <ChevronType1
                showArrows = {!isMobile}
                showChevrons
                handlePrevClick={handlePrevClick}
                handleNextClick={() => handleNextClick(config?.post?.child_media)}
                isAutoPlayOn={false}
                currentActiveSlideIndex={currentSlideActive}
                chevronAnimationTiming={0}
                arrowPosition={'center'}
                images={config?.post?.child_media}
                bgOpacity={1}
                height= {24}
                width = {24}
                isShadowTypeIcon
                arrowColor={'#111C36'}
                arrowType={'v1'}
                showGradient
                containerClass={isMobile ? '!tw-px-[12px]' : '!tw-px-[24px]'}
              />
            </div>
            {
              config?.post?.child_media?.map((childData) => {
                return (
                  <div key={childData?.media_url} className={'tw-flex tw-bg-black tw-items-center tw-justify-items-center tw-w-[100%]'}>
                    {
                      isVideoUrl(childData?.media_url) ? renderVideo(childData?.media_url, style) : renderImage(childData?.media_url, style)
                    }
                  </div>
                )

              })
            }
          </div>
        </div>
      )
    }
    return config.type === 'image' ? renderImage(mediaUrl) : renderVideo(mediaUrl)
  }

  function renderProfile() {
    const userDetails = config.userDetails;
    return (
      <div style={{ borderBottom: '1px solid #E6E6E6' }} className={`tw-px-[16px] tw-py-[12px] ${isMobile ? 'tw-bg-[#FFFFFF] tw-max-w-[768px]' : 'tw-w-[100%]'}`}>
        <div className='tw-flex tw-items-center tw-gap-[12px]'>
          <img src={userDetails?.profile_picture_url} height={'40px'} width={'40px'} className='tw-rounded-[100px] tw-object-cover' />
          <div className='tw-text-[14px] tw-font-medium tw-text-newBlack'>{userDetails?.username}</div>
        </div>
      </div>
    )
  }

  function renderContent() {
    const parentMedia = config?.post?.parent_media;
    const caption = parentMedia?.caption;
    const postDate = formatDate(parentMedia?.timestamp)
    const showTrimedContent = caption?.length > 140;
    return (
      <div className={`tw-bg-white ${!isMobile ? 'tw-w-[358px] tw-max-w-[358px] tw-rounded-tr-[12px] tw-rounded-br-[12px] tw-h-[100%]' : 'tw-w-[100%] tw-max-w-[768px] tw-h-max tw-relative'}`}>
        {!isMobile && renderProfile()}
        {isMobile ?
          <div className={`tw-py-[24px] tw-px-[16px] tw-text-[14px] tw-font-normal tw-leading-[1.4]`}>
            {(showTrimedContent && showReadMore) ? <span>{`${caption?.substring(0, 140)} ... `}</span> : <span>{caption}</span>}
            {(showReadMore && showTrimedContent) && <span onClick={() => setShowReadMore(false)} className='tw-text-[14px] tw-font-semibold tw-text-newBlack tw-cursor-pointer'>{'Read more'}</span>}
          </div>
          :
          <div className={`tw-py-[24px] tw-px-[16px] tw-text-[14px] tw-font-normal tw-leading-[1.4] tw-max-h-[480px] tw-overflow-scroll`}>
            {caption}
          </div>
        }
        <div className={`tw-text-[13px] tw-font-normal tw-text-newBlack tw-opacity-70 tw-px-[16px] ${!isMobile ? 'tw-absolute tw-bottom-[16px]' : 'tw-pb-[16px]'}`}>{postDate}</div>
      </div>
    )
  }

  function renderCloseIcon() {
    return <div onClick={handleClose} className={`ic-cross-bg-black-lg wb-sprite ${isMobile ? 'tw-absolute tw-top-[-50px] tw-right-[44%]' : ' tw-fixed  tw-top-[20px] tw-right-[20px]'}`}></div>
  }

  return (
    <Modal
      open={config.showModal}
      className={`${!isMobile ? 'tw-flex tw-items-center tw-flex-col tw-justify-center' : 'tw-flex tw-flex-col tw-justify-end'} tw-bg-[#00000033]`}
      slotProps={{
        backdrop: {
          sx: {
            background: '##000000b3',
          },
        },
      }}
    >
      <div className={!isMobile ?  `tw-flex tw-items-center tw-h-[100%] tw-w-[1200px]` : ''}>
      {!isMobile && <ArrowIcon
        onClick={handlePrevPost}
        arrowDirection="left"
        arrowType={'v1'}
        imageProps={{
          className: 'tw-mr-[10px]',
          bgColor: 'white',
          arrowColor: 'black',
          bgOpacity: 1,
          width: 48,
          height: 48
        }}
      />}
      {!isMobile ? <div className={`tw-rounded-[12px] tw-h-[90%] tw-max-h-[600px] tw-mx-auto tw-flex tw-relative`}>
        {renderImageAndVideo(config)}
        {renderContent()}
        {renderCloseIcon()}
      </div> :
        <div className={`tw-rounded-[12px] tw-max-w-[768px] tw-relative`}>
          {renderProfile()}
          <div style={{ maxHeight: getMaxHeight() }} ref={mobilePostRef} className='tw-flex tw-flex-col tw-overflow-scroll'>
            {renderImageAndVideo(config)}
            {renderContent()}
            {renderCloseIcon()}
          </div>
        </div>
      }
      {!isMobile && <ArrowIcon
        onClick={handleNextPost}
        arrowDirection="right"
        arrowType={'v1'}
        imageProps={{
          className: 'tw-ml-[10px]',
          bgColor: 'white',
          arrowColor: 'black',
          bgOpacity: 1,
          width: 48,
          height: 48
        }}
      />}
      </div>
    </Modal>
  )
}

export default RenderInstaModal;